import { Component } from "@kluntje/core";

class FRANumberInput extends Component {
  constructor() {
    super({
      ui: {
        input: ".fra-js-number-input__input :-one",
        decrement: ".fra-js-number-input__button--decrement :-one",
        increment: ".fra-js-number-input__button--increment :-one",
      },

      events: [
        {
          event: "click",
          target: "decrement",
          handler: "handleDecrement",
        },
        {
          event: "click",
          target: "increment",
          handler: "handleIncrement",
        },
        // when the use tab navigates to the input and changes it
        {
          event: "change",
          target: "input",
          handler: "handleChange",
        },
      ],
    });
  }

  /**
   * update disabled attributes in case server hasn't rendered them correctly / on page refresh were old values is re-used
   */
  afterComponentRender(): void {
    this.setDisableAttributes();
  }

  /**
   * return the `value` of the inner input[type=number] and cast it to number,
   * `0` is the fallback/default value
   */
  get value() {
    const value = this.ui.input.value || "0";
    return parseInt(value, 10);
  }

  set value(value: number) {
    this.ui.input.value = String(value);
    this.handleChange();
  }

  get stepInterval(): number {
    const { input } = this.ui;
    return input.getAttribute("step") !== null ? parseInt(input.getAttribute("step"), 10) : 1;
  }

  /**
   * Get max attribute
   */
  get max(): number {
    const { input } = this.ui;
    return parseInt(input.getAttribute("max"), 10);
  }

  /**
   * Get min attribute
   */
  get min(): number {
    const { input } = this.ui;
    return parseInt(input.getAttribute("min"), 10);
  }

  /**
   * Increment the input one step
   */
  handleIncrement(): void {
    if (this.value !== this.max) this.value += this.stepInterval;
  }

  /**
   * Decrement the input one step
   */
  handleDecrement(): void {
    if (this.value !== this.min) this.value -= this.stepInterval;
  }

  /**
   * Disable increment and decrement button if the max or min input range is reached
   */
  setDisableAttributes() {
    const { decrement, increment } = this.ui;

    switch (this.value) {
      case this.max:
        increment.setAttribute("disabled", "");
        decrement.removeAttribute("disabled");
        break;

      case this.min:
        increment.removeAttribute("disabled");
        decrement.setAttribute("disabled", "");
        break;

      default:
        increment.removeAttribute("disabled");
        decrement.removeAttribute("disabled");
        break;
    }
  }

  /**
   *  Dispatch a custom event when the input change its value
   */
  handleChange(): void {
    this.setDisableAttributes();

    this.dispatchEvent(
      new CustomEvent("fra-number-input-changed", {
        detail: {
          value: this.value,
        },
      }),
    );
  }
}

customElements.define("fra-m-number-input", FRANumberInput);

export default FRANumberInput;
